import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import type { DataCategory } from 'webapp/enums/enums';

import FilterSortAvailableSource, {
	AvailableSourceSortBy,
} from 'webapp/models-custom/filter-sort/available-source';
import type { FilterIdType, FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import type { FilterOption } from 'webapp/models-custom/filter-sort/filter';
import type Filter from 'webapp/models-custom/filter-sort/filter';
import type SourceType from 'webapp/models-custom/source-type';

export default class FilterSortAvailableSourceInOnboarding extends FilterSortAvailableSource {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	@tracked override sortProp = 'suggestionScore';

	override saveFilterInUrlHash = false;

	constructor(options: FilterSortSettings<SourceType>) {
		super(options);

		// Categories (from onboarding experiment)
		const categoryFilter = this.createFilter<string>({
			id: 4,
			label: 'Category',
			name: 'category',
			stringValues: true,
			selected: 'all',
			isMultiSelect: true,
			getOptions: () => {
				return this.onboardingCategoryOptions;
			},
			filterFn: (item, selected) => {
				return selected.some((categoryId) => {
					if (categoryId === 'all') {
						return true;
					}
					const sourceTypeCategories =
						this.mmSourceTypesService.getSourceTypeCategoriesForDataCategory(
							categoryId as DataCategory,
						);
					return item.categories.some((categoryName: string) => {
						return sourceTypeCategories.includes(categoryName);
					});
				});
			},
		}) as Filter<SourceType, FilterIdType>;

		next(() => {
			// move to start
			this.filters = [categoryFilter, ...this.filters.filter((f) => f !== categoryFilter)];
		});
	}

	get onboardingCategoryOptions() {
		const categories: FilterOption<string>[] =
			this.mmSourceTypesService.dataCategoryOptions.map((category) => {
				return {
					id: category.id,
					text: category.title,
				};
			});
		categories.unshift({ id: 'all', text: 'All' });
		return categories;
	}

	override updateSortBy(sortBy: AvailableSourceSortBy): void {
		if (sortBy === AvailableSourceSortBy.POPULARITY) {
			this.sortProp = 'suggestionScore';
		} else {
			super.updateSortBy(sortBy);
		}
	}
}
